import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "25",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#3126AD",
  d: "M7.265 16.878v5.775c0 .341.184.655.49.812.316.169.674.14.95-.055L12 21.157l3.296 2.262a.9.9 0 0 0 .95.046.91.91 0 0 0 .49-.812v-5.775c2.329-1.581 3.729-4.177 3.729-7 0-4.662-3.803-8.456-8.465-8.456-4.67 0-8.464 3.794-8.464 8.455 0 2.824 1.4 5.42 3.729 7.001m.969-7.933a.97.97 0 0 1 .785-.674l1.421-.203.683-1.32c.333-.674 1.422-.674 1.763 0l.628 1.283 1.468.24c.369.056.674.314.784.674a.96.96 0 0 1-.249 1.006l-1.024.997-.01.055.24 1.413a.98.98 0 0 1-.397.96.99.99 0 0 1-1.033.074l-1.265-.665-1.32.665a.98.98 0 0 1-1.034-.074 1 1 0 0 1-.397-.96l.25-1.413-1.044-1.052a.96.96 0 0 1-.249-1.006"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }